import { ToastStore } from "../../react/stores/ToastStore";
import { addToBookmarks, removeFromBookmarks } from "../../react/api";
import { Globals } from "../../react/utils";

export function initApaArticleBookmark() {

	//Bookmark event
	const articleBookmarkButtons = document.querySelectorAll(".js-apa-science-bookmark");
	if (articleBookmarkButtons) {
		articleBookmarkButtons.forEach((element) => {
			element.addEventListener("click", function(e) {
				e.preventDefault();

				const articleId = element.dataset.apaId;

				if (!articleId) {
					return;
				}

				const url = Globals.wishlistUrl;

				let imageElement = "";
				// if we on apa article view page
				if(document.querySelector(".apa-science-page")) {
					imageElement = document.querySelector(".image-cover img");
				}
				// if we on apa articles list page
				else {
					imageElement = element.closest("a.card-element-format-apa").querySelector("img");
				}

				const image = imageElement ? imageElement.src : null;

				if (element.classList.contains("active")) {
					// eslint-disable-next-line no-undef
					removeFromBookmarks(articleId);
					element.classList.remove("active");
					ToastStore.removeFromBookmark(
						image ?? "",
						url ?? "",
						null,
						"apa-article"
					);

					// if we on apa article view page
					if(document.querySelector(".apa-science-page")) {
						const bookmark_text = document.getElementById("apa-article-bookmark-text");
						const bookmark_text_logged_out = document.getElementById("apa-article-bookmark-text-logged-out");
						if(bookmark_text) {
							bookmark_text.innerHTML = "Merkliste";
							bookmark_text.setAttribute("title", "Zur Merkliste hinzufügen");
						}
						if(bookmark_text_logged_out) {
							bookmark_text_logged_out.innerHTML = "Merkliste";
							bookmark_text_logged_out.setAttribute("title", "Zur Merkliste hinzufügen");
						}

					}

				} else {
					// eslint-disable-next-line no-undef
					addToBookmarks(articleId);
					element.classList.add("active");
					ToastStore.addToBookmark(
						image ?? "",
						url ?? "",
						null,
						"apa-article"
					);

					// if we on apa article view page
					if(document.querySelector(".apa-science-page")) {
						const bookmark_text = document.getElementById("apa-article-bookmark-text");
						const bookmark_text_logged_out = document.getElementById("apa-article-bookmark-text-logged-out");
						if(bookmark_text) {
							bookmark_text.innerHTML = "Merkliste";
							bookmark_text.setAttribute("title", "Von Merkliste entfernen");
						}
						if(bookmark_text_logged_out) {
							bookmark_text_logged_out.innerHTML = "Merkliste";
							bookmark_text_logged_out.setAttribute("title", "Von Merkliste entfernen");
						}
					}
				}
			})

		})
	}

	if(document.querySelector(".apa-science-page")) { // if we on apa article view page
		const bookmark_text = document.getElementById("apa-article-bookmark-text");
		const bookmark_text_logged_out = document.getElementById("apa-article-bookmark-text-logged-out");

		if(bookmark_text) {
			if(bookmark_text.classList.contains("active")) {
				bookmark_text.innerHTML = "Merkliste";
				bookmark_text.setAttribute("title", "Von Merkliste entfernen");
			}
			else {
				bookmark_text.innerHTML = "Merkliste";
				bookmark_text.setAttribute("title", "Zur Merkliste hinzufügen");
			}
		}

		if(bookmark_text_logged_out) {
			if(bookmark_text_logged_out.classList.contains("active")){
				bookmark_text_logged_out.innerHTML = "Merkliste";
				bookmark_text_logged_out.setAttribute("title", "Von Merkliste entfernen");
			}
			else {
				bookmark_text_logged_out.innerHTML = "Merkliste";
				bookmark_text_logged_out.setAttribute("title", "Zur Merkliste hinzufügen");
			}
		}

	}
}